<template>
    <div class="tariff">
        <modal v-model="showTariff">
            <div class="modal-content">
                <div ref="slider" id="slider" class="tariff-slider">
                    <div v-for="(item, key) in tariffList"
                         :key="key"
                         class="card">
                        <div class="card-headline">
                            <radio-btn :value="item.value"
                                       @change="changeTariff(key)">
                                {{item.title}}
                            </radio-btn>
                            <div v-if="item.deltaPrice" class="ml-5">
                                <span class="standard-text">{{getPlus(item.deltaPrice)}}{{correctPrice(item.deltaPrice) }}</span>
                                <span class="standard-500-text ml-2">{{getCurrencyDisplayInSearch(rate)}}</span>
                            </div>
                        </div>
                        <div class="card-body">
                            <div v-for="(item2, key2) in item.universalParametrs"
                                 :key="key2">
                                <h4 :class="['content-headline', key2 > 0 ? 'mt-10' : '']">{{ item.titles[key2] }}</h4>
                                <div v-for="(item3, key3) in item2"
                                     :key="key3"
                                     class="align-center mb-3">
                                    <icon v-if="item3.status === 1"
                                          name="aviailable"
                                          width="14px" height="14px" fill="var(--white-color)" />
                                    <icon v-else-if="item3.status === 2"
                                          name="dollar"
                                          style="transform: scale(1.25) translate(-0.4px, 0.4px)"
                                          width="14px" height="14px" fill="var(--yellow-color)" />
                                    <icon v-else
                                          name="not-aviailable"
                                          width="14px" height="14px" fill="var(--white-color)" />
                                    <p class="card-text">{{item3.text}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="tariff-btn-wrap justify-between align-center">
                    <div class="align-center">
                        <base-button @click.native="slide(-1)" background="var(--white-color)" padding="13px 10px" class="mr-5">
                            <icon name="angle" width="14px" height="9px" fill="#000" class="left-angle"/>
                        </base-button>
                        <base-button @click.native="slide(1)" background="var(--white-color)" padding="13px 10px">
                            <icon name="angle" width="14px" height="9px" fill="#000" class="right-angle"/>
                        </base-button>
                    </div>
                    <div @mouseleave="hidePopover()"
                         @mouseenter="showPopover(getSelectText(), $event)">
                        <base-button @click.native="chooseTariff()">{{localizeList.btnTextTariffChooseUpper}}</base-button>
                    </div>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
    export default {
        name: "tariff",
        props: {
            show: {
                type: Boolean,
                default: false
            },
            tariff: {
                type: Array,
                default: () => []
            },
            rate: {
                type: String,
                default: ""
            }
        },
        data() {
            return {
                tariffList: [],
                cardWidth: 310,
                cardSpace: 10,
                showTariff: false,
                test: false,
                sliderPress: false,
                sliderDrag: false,
                dragEnd: true,
                dragEndX: 0,
                dragX: 0,
                pressStart: 0,
                sliderPosition: 0
            }
        },
        mounted() {
            this.$refs.slider.addEventListener('mousedown', this.press);
            window.addEventListener('mouseup', this.pressOut);
            window.addEventListener('mousemove', this.drag);
            this.showTariff = this.show;
        },
        methods: {
            getCurrencyDisplayInSearch(code){
                let allRate=this.$store.getters['getCurrency'];
                let rate=allRate.find(x=>x.Code===code);

                return this.$store.getters['getCurrencyDisplayBySettings'](rate);
            },
            getPlus(n) {
                return n > 0 ? "+" : ""
            },
            correctPrice(val) {
                const isFloat = val % 1 !== 0;
                let res = new Intl.NumberFormat().format(val);

                if (res.includes(".") || !isFloat) {
                    res = res.replace(/,/g, " ");
                } else {
                    res = res.replace(/,/g, ".");
                }
                res = (res.includes("NaN") || isNaN(parseInt(res))) ? "" : res;
                return res
            },
            chooseTariff() {
                const selectedTariff = this.tariffList.find(x => x.value);

                this.$emit("change", selectedTariff);
                this.showTariff = false;
            },
            changeTariff(key) {
                this.tariffList = this.tariffList.map((x, i) => {
                    x.value = i === key;
                    return x
                })
            },
            press(e) {
                this.sliderPress = true;
                this.pressStart = e.pageX
            },
            pressOut() {
                if (this.sliderPress && this.sliderDrag) {
                    this.sliderPosition = Math.round((this.dragX + 1) / this.cardWidth);
                    this.dragEndX = this.sliderPosition * this.cardWidth + this.sliderPosition * this.tariffList.length;

                    this.slide();
                }

                this.sliderPress = false;
                this.sliderDrag = false;
                this.dragEnd = true;
            },
            drag(e) {
                if(!this.sliderPress || this.tariffList.length <= 3) {
                    return
                }
                this.sliderDrag = true;
                e.preventDefault();

                let slider = document.getElementById('slider');
                let x = this.pressStart - e.pageX + this.dragEndX;
                // slider.scrollTo(x, 0);
                if(this.isIEorEdge() !== -1) {
                    slider.scrollLeft = x
                } else {
                    slider.scrollTo(x, 0);
                }

                this.dragX = x;
            },
            slide(n = null) {
                if(n && this.sliderPosition + n >= 0 && this.sliderPosition + n < this.tariffList.length - 2) {
                    this.sliderPosition += n;
                    this.dragEndX = this.cardWidth * this.sliderPosition;
                }

                let slider = document.getElementById('slider');
                let scrollTo = this.sliderPosition * (this.cardWidth + this.cardSpace);

                if(this.isIEorEdge() !== -1) {
                    slider.scrollLeft = scrollTo
                } else {
                    slider.scrollTo({
                        left: scrollTo,
                        behavior: "smooth"
                    });
                }
            },
            isIEorEdge() {
                let rv = -1;
                if (navigator.appName == 'Microsoft Internet Explorer')
                {
                    let ua = navigator.userAgent;
                    let re  = new RegExp("MSIE ([0-9]{1,}[.0-9]{0,})");
                    if (re.exec(ua) != null)
                        rv = parseFloat( RegExp.$1 );
                }
                else if (navigator.appName == 'Netscape')
                {
                    if(navigator.appVersion.includes("Edge")){
                        return "Edge"
                    }
                    let ua = navigator.userAgent;
                    let re  = new RegExp("Trident/.*rv:([0-9]{1,}[.0-9]{0,})");
                    if (re.exec(ua) != null)
                        rv = parseFloat( RegExp.$1 );
                }
                return rv;
            },
            getSelectText() {
                const selectedTariff = this.tariffList.find(x => x.value);
                return `${ this.localizeList.selectTariffUpper } <span class="nowrap">${ this.getPlus(selectedTariff.deltaPrice) }${this.correctPrice(selectedTariff.deltaPrice) } ${ this.getCurrencyDisplayInSearch(this.rate)}</span>`
            },
            showPopover(text, e) {
                let rect = e.target.getBoundingClientRect()
                let res = {
                    x: rect.left + (rect.width / 2),
                    y: rect.top,
                    text: text,
                    height: rect.height
                }
                this.$store.dispatch('A_SHOW_POPOVER', res)
            },
            sortInuversalParam(array) {
                return array.sort(function (a, b) {
                    return a.number > b.number ? 1 : -1;
                });
            }
        },
        watch: {
            dragX(val) {
                if(this.tariffList.length > 3){
                    if(val < 0) {
                        this.dragX = 0;
                    }
                    const max = (this.tariffList.length * this.cardWidth) + ((this.tariffList.length-1) * this.cardSpace) - (this.cardWidth * 3) - (this.cardSpace * 3);
                    if(val > max) {
                        this.dragX = max
                    }
                }
            },
            showTariff(val) {
                if (!val) {
                    this.$emit("hide")
                }
            },
            tariff: {
                deep: true,
                handler(val) {
                    let list = val.map(x => {
                        x.value = x.deltaPrice === 0;
                        x.universalParametrs = [];
                        const titles = [];

                        x.universalParametrsSequence.forEach(x2 => {
                            let free = [];
                            let charge = [];
                            let notAviabillity = [];
                            x2.universalParametrs.forEach(x3 => {
                                if(x3.code === "description"){
                                    titles.push(x3.shortDescriptions[0].value);
                                    x.title = (x.title ? x.title + ", " : "") + x3.shortDescriptions[0].value;
                                } else {
                                    const param = {
                                        status: status,
                                        code: x3.code,
                                        number: 0,
                                        text: ""
                                    };

                                    if (x3.code === 'carry_on') {
                                        param.number = 1;
                                        param.text = this.localizeList.carryOnRestrictionUpper +": "+ x3.shortDescriptions[0].value;
                                    }
                                    else if (x3.code === 'baggage') {
                                        param.number = 2;
                                        param.text = this.localizeList.baggageRestrictionUpper +": "+ x3.shortDescriptions[0].value;
                                    }
                                    else {
                                        param.number = 3;
                                        param.text = x3.shortDescriptions[0].value;
                                    }

                                    if (x3.needToPay === 'Free') {
                                        param.status = 1;
                                        free.push(param)
                                    } else if (x3.needToPay === 'Charge') {
                                        param.status = 2;
                                        charge.push(param)
                                    } else {
                                        param.status = 3;
                                        notAviabillity.push(param)
                                    }
                                }
                            });
                            free = this.sortInuversalParam(free);
                            charge = this.sortInuversalParam(charge);
                            notAviabillity = this.sortInuversalParam(notAviabillity);

                            x.universalParametrs.push([...free, ...charge, ...notAviabillity])
                        });
                        x.titles = titles;

                        return x
                    });

                    this.tariffList = list;
                }
            },
            show(val) {
                this.showTariff = val
            },
        },
        beforeDestroy() {
            this.$refs.slider.removeEventListener('mousedown', this.press);
            window.removeEventListener('mouseup', this.pressOut);
            window.removeEventListener('mousemove', this.drag);
        }
    }
</script>

<style scoped>
    .tariff /deep/.base-modal .base-modal-content-wrap {
        padding: 50px 0;
    }
    .tariff /deep/.base-modal .base-modal-content {
        width: 1000px;
        background-color: #f1f1f1;
    }

    .modal-content {
        padding: 50px 22px 30px;
    }

    .tariff-slider {
        overflow: hidden;
        display: flex;
        padding: 10px 0;
    }

    .tariff-slider .card {
        min-width: 310px;
        background: var(--white-color);
        border-radius: 4px;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
    }

    .tariff-slider .card:not(:last-child) {
        margin-right: 10px;
    }

    .tariff-slider .card .card-headline {
        padding: 10px 0;
        border-bottom: 1px solid #aaa;
        display: flex;
        justify-content: center;
    }

    .tariff-slider .card .card-headline /deep/.radio-btn {
        width: max-content;
        font-size: 14px;
    }

    .tariff-slider .card-body {
        padding: 10px;
        max-height: 300px;
        overflow-y: auto;
    }

    .tariff-slider .card-body .content-headline {
        font-size: 14px;
        font-weight: 400;
        margin-bottom: 6px;
    }

    .tariff-slider .card-body svg {
        min-width: 14px;
    }

    .tariff-slider .card-body .card-text {
        font-size: 13px;
        margin-left: 6px;
        font-weight: 200;
    }

    .tariff-btn-wrap {
        padding-top: 10px;
    }

    .tariff-btn-wrap .left-angle {
        transform: rotate(90deg);
    }

    .tariff-btn-wrap .right-angle {
        transform: rotate(-90deg);
    }

    .tariff-btn-wrap /deep/.base-button {
        font-size: 14px;
    }

</style>
